import axiosService from "./axios.service";

export interface Branding {
    displayName?: string;
    logoUrl?: string;
    bannerUrl?: string;
    primaryColor?: string;
    accentColor?: string;
    fontFamily?: string;
}

// must match BRANDING_FONTS on the server
export const BRANDING_FONTS = [
    'Inter',
    'Space Grotesk',
    'Plus Jakarta Sans',
    'DM Sans',
    'IBM Plex Sans',
    'Montserrat',
    'Poppins',
    'Lora',
    'Roboto'
];

export const ACCEPTED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];

/**
 * Organization branding with hackathon overrides applied field-by-field. Empty values inherit.
 */
export const resolveBranding = (...sources: Array<Branding | null | undefined>): Branding => {
    const result: Branding = {};
    sources.forEach(source => {
        if (!source) {
            return;
        }
        (Object.keys(source) as Array<keyof Branding>).forEach(key => {
            if (source[key]) {
                result[key] = source[key];
            }
        });
    });
    return result;
}

export const hasBranding = (branding: Branding | null | undefined) => {
    return !!branding && Object.values(branding).some(Boolean);
}

export const uploadBrandAsset = async (file: File): Promise<string> => {
    const { data } = await axiosService.post('/api/brand-assets', file, {
        headers: {
            'Content-Type': file.type
        }
    });
    return data.url;
}

// fonts already fetched; the default look fetches none
const loadedFonts = new Set<string>();

const loadGoogleFont = (font: string) => {
    if (loadedFonts.has(font)) {
        return;
    }
    loadedFonts.add(font);
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(font)}:wght@400;500;600;700;800&display=swap`;
    document.head.appendChild(link);
}

/**
 * Lazily loads a Google Font the first time a branded page needs it.
 */
export const ensureFontLoaded = (font: string | undefined) => {
    if (font && BRANDING_FONTS.includes(font)) {
        loadGoogleFont(font);
    }
}

